import { NavLink, Outlet } from "react-router-dom";
import { Button } from "@admin/components/ui/button";
import type { AdminMe } from "@admin/lib/api";
import { cn } from "@admin/lib/utils";

const links = [
  { to: "/", label: "Overview", end: true },
  { to: "/contact", label: "Contact" },
  { to: "/newsletter", label: "Newsletter" },
  { to: "/users", label: "Users" },
  { to: "/hibernation", label: "Hibernation" },
  { to: "/hire/codes", label: "Hire codes" },
  { to: "/hire/rewards", label: "Hire rewards" },
  { to: "/revenue", label: "Revenue" },
  { to: "/spend", label: "Spend" },
  { to: "/conversations", label: "Conversations" },
  { to: "/reconciliation", label: "Reconciliation" },
  { to: "/incidents", label: "Incidents" },
  { to: "/slack-queue", label: "Slack queue" },
  { to: "/mysql-tables", label: "Database tables" },
];

export function AdminShell({
  me,
  onLogout,
}: {
  me: AdminMe;
  onLogout: () => void;
}) {
  return (
    <div className="flex min-h-full">
      <aside className="flex w-56 shrink-0 flex-col border-r border-border bg-muted/30 p-4">
        <div className="mb-6">
          <div className="text-sm font-semibold">John CEO Ops</div>
          <div className="truncate text-xs text-muted-fg">{me.email}</div>
        </div>
        <nav className="flex flex-1 flex-col gap-1">
          {links.map((l) => (
            <NavLink
              key={l.to}
              to={l.to}
              end={l.end}
              className={({ isActive }) =>
                cn(
                  "rounded-lg px-3 py-2 text-sm transition-colors",
                  isActive ? "bg-accent/20 text-fg" : "text-muted-fg hover:bg-muted hover:text-fg",
                )
              }
            >
              {l.label}
            </NavLink>
          ))}
        </nav>
        <Button variant="outline" size="sm" onClick={onLogout}>
          Sign out
        </Button>
      </aside>
      <main className="flex-1 overflow-auto p-6">
        <Outlet />
      </main>
    </div>
  );
}
